import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "container animated fadeIn" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 mb-3 text-left" }, "Profile")
  ])
], -1)
const _hoisted_3 = { class: "row mb-3 mt-3" }
const _hoisted_4 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("b", null, "Name", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("b", null, "Last Name", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_14 = /*#__PURE__*/_createVNode("b", null, "Date of Birth", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_18 = /*#__PURE__*/_createVNode("b", null, "Phone Number", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_22 = /*#__PURE__*/_createVNode("b", null, "Occupation", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode()
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("option", {
  value: null,
  disabled: ""
}, "Select an option", -1)
const _hoisted_26 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_27 = /*#__PURE__*/_createVNode("b", null, "Email", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode()
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { class: "row mb-3 mt-3" }
const _hoisted_31 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_32 = /*#__PURE__*/_createVNode("b", null, "Address Line 1", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode()
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_36 = /*#__PURE__*/_createVNode("b", null, "Address Line 2", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode()
const _hoisted_38 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_39 = { class: "row mb-3" }
const _hoisted_40 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_41 = /*#__PURE__*/_createVNode("b", null, "City", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode()
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_45 = /*#__PURE__*/_createVNode("b", null, "Province", -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode()
const _hoisted_47 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_48 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_49 = /*#__PURE__*/_createVNode("b", null, "Street", -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode()
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = { class: "row mb-3" }
const _hoisted_53 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_54 = /*#__PURE__*/_createVNode("b", null, "Street Number", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode()
const _hoisted_56 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_57 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_58 = /*#__PURE__*/_createVNode("b", null, "Interior Number", -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode()
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_62 = /*#__PURE__*/_createVNode("b", null, "Postal Code", -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode()
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = { class: "row mb-3 mt-3" }
const _hoisted_66 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_67 = /*#__PURE__*/_createVNode("b", null, " Are you involved, related, or closely associated with any members of government? ", -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode()
const _hoisted_69 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_70 = { class: "form-check form-check-inline" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label mr-3",
  for: "yesOption"
}, " Yes ", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "noOption"
}, "No", -1)
const _hoisted_73 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_74 = /*#__PURE__*/_createVNode("b", null, "User Since", -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode()
const _hoisted_76 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_77 = { class: "row mt-4 mb-3" }
const _hoisted_78 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_79 = { class: "row mt-3 mb-3 justify-content-between" }
const _hoisted_80 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_81 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_82 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_83 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_88 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_89 = { class: "row mt-4" }
const _hoisted_90 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_91 = /*#__PURE__*/_createVNode("small", null, " By setting up and Anti-phishing Code, you will be able to know if the emails and 2FA are from Satstreet or phishing attempts. ", -1)
const _hoisted_92 = { class: "mt-3 row" }
const _hoisted_93 = { class: "col-lg-8 col-md-8 col-sm-12" }
const _hoisted_94 = {
  id: "anti-phishing-word-help",
  class: "form-text"
}
const _hoisted_95 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-shield-alt" }),
  /*#__PURE__*/_createTextVNode(" We recommend changing the code every 30 days to enhance account security. ")
], -1)
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col text-right" }
const _hoisted_100 = /*#__PURE__*/_createVNode("small", null, " Need help? Check out our help page for answers and guidance. Click here to access the help section. ", -1)
const _hoisted_101 = { class: "mt-3" }
const _hoisted_102 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://satstreet.com/services/privacypolicy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Privacy Policy ")
], -1)
const _hoisted_103 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://satstreet.com/services/risk-statements",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Risk Statements ")
], -1)
const _hoisted_104 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://satstreet.com/services/legal-disclosures",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Legal Disclosures ")
], -1)
const _hoisted_105 = { class: "container" }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("h2", null, "Terms of service")
  ])
], -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Verify2fa = _resolveComponent("Verify2fa")
  const _component_TwoFactorAuthenticator = _resolveComponent("TwoFactorAuthenticator")
  const _component_Panel = _resolveComponent("Panel")
  const _component_Password = _resolveComponent("Password")
  const _component_Terms = _resolveComponent("Terms")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Verify2fa, {
      show: _ctx.showVerify,
      email: 'hernny.malaver@gmail.com',
      returnCode: true,
      onClose: _ctx.close2fa,
      onSuccess: _ctx.success2fa
    }, null, 8, ["show", "email", "onClose", "onSuccess"]),
    _createVNode(_component_TwoFactorAuthenticator, {
      show: _ctx.modalShow,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShow = false))
    }, null, 8, ["show"]),
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Panel, {
        header: "Personal Information",
        class: "shadow mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.firstName || '--'), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.lastName || '--'), 1)
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.dateOfBirth || '--'), 1)
            ]),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.phoneNumber || '--'), 1)
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              (!_ctx.isOtherOccupation)
                ? _withDirectives((_openBlock(), _createBlock("select", {
                    key: 0,
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.occupation = $event))
                  }, [
                    _hoisted_25,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.occupationsData, (oc) => {
                      return (_openBlock(), _createBlock("option", {
                        key: oc,
                        value: oc
                      }, _toDisplayString(oc), 9, ["value"]))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.form.occupation]
                  ])
                : _createCommentVNode("", true),
              (_ctx.isOtherOccupation)
                ? _withDirectives((_openBlock(), _createBlock("input", {
                    key: 1,
                    type: "text",
                    class: "form-control text-center",
                    id: "occupation",
                    name: "occupation",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.occupation = $event)),
                    placeholder: "Occupation"
                  }, null, 512)), [
                    [_vModelText, _ctx.form.occupation]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_26, [
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.email || '--'), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        header: "Address Information",
        class: "shadow mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.addressLine1 || '--'), 1)
            ]),
            _createVNode("div", _hoisted_35, [
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.addressLine2 || '--'), 1)
            ])
          ]),
          _createVNode("div", _hoisted_39, [
            _createVNode("div", _hoisted_40, [
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.city || '--'), 1)
            ]),
            _createVNode("div", _hoisted_44, [
              _hoisted_45,
              _hoisted_46,
              _hoisted_47,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.province || '--'), 1)
            ]),
            _createVNode("div", _hoisted_48, [
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.street || '--'), 1)
            ])
          ]),
          _createVNode("div", _hoisted_52, [
            _createVNode("div", _hoisted_53, [
              _hoisted_54,
              _hoisted_55,
              _hoisted_56,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.streetNumber || '--'), 1)
            ]),
            _createVNode("div", _hoisted_57, [
              _hoisted_58,
              _hoisted_59,
              _hoisted_60,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.interiorNumber || '--'), 1)
            ]),
            _createVNode("div", _hoisted_61, [
              _hoisted_62,
              _hoisted_63,
              _hoisted_64,
              _createTextVNode(" " + _toDisplayString(_ctx.userProfile.postalCode || '--'), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        header: "Account Details",
        class: "shadow mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_65, [
            _createVNode("div", _hoisted_66, [
              _hoisted_67,
              _hoisted_68,
              _hoisted_69,
              _createVNode("div", _hoisted_70, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "inlineRadioOptions",
                  id: "yesOption",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.government = $event)),
                  value: true
                }, null, 512), [
                  [_vModelRadio, _ctx.form.government]
                ]),
                _hoisted_71,
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "inlineRadioOptions",
                  id: "noOption",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.government = $event)),
                  value: false
                }, null, 512), [
                  [_vModelRadio, _ctx.form.government]
                ]),
                _hoisted_72
              ])
            ]),
            _createVNode("div", _hoisted_73, [
              _hoisted_74,
              _hoisted_75,
              _hoisted_76,
              _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.userProfile.createdAt, 'YYYY-MM-DD')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_77, [
            _createVNode("div", _hoisted_78, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updatedMyProfile && _ctx.updatedMyProfile(...args))),
                class: "btn btn-primary btn-sat-street"
              }, " Save Information ")
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        header: "Reset Password",
        class: "shadow mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_79, [
            _createVNode("div", _hoisted_80, [
              _createVNode(_component_Password, {
                style: {"width":"100%"},
                inputStyle: "width:100%",
                toggleMask: "",
                feedback: false,
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.password = $event)),
                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$v.password.$touch())),
                placeholder: "Enter Current Password"
              }, null, 8, ["modelValue"]),
              _createVNode("small", {
                class: {
              'text-danger': _ctx.password == '',
              'text-success': _ctx.password != ''
            }
              }, "Value is required", 2),
              _hoisted_81,
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.password.minLength.$invalid || _ctx.password == '',
              'text-success': !_ctx.$v.password.minLength.$invalid
            }
              }, "The min length value is 8", 2)
            ]),
            _createVNode("div", _hoisted_82, [
              _createVNode(_component_Password, {
                style: {"width":"100%"},
                inputStyle: "width:100%",
                toggleMask: "",
                feedback: false,
                modelValue: _ctx.newPassword,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.newPassword = $event)),
                onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$v.newPassword.$touch())),
                placeholder: "Enter New Password"
              }, null, 8, ["modelValue"]),
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.newPassword.required.$invalid,
              'text-success': !_ctx.$v.newPassword.required.$invalid
            }
              }, "Value is required", 2),
              _hoisted_83,
              _createVNode("small", {
                class: {
              'text-danger':
                _ctx.$v.newPassword.minLength.$invalid || _ctx.newPassword == '',
              'text-success': !_ctx.$v.newPassword.minLength.$invalid
            }
              }, "The min length value is 8", 2),
              _hoisted_84,
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.newPassword.containsUppercase.$invalid,
              'text-success': !_ctx.$v.newPassword.containsUppercase.$invalid
            }
              }, "An uppercase value is required", 2),
              _hoisted_85,
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.newPassword.containsLowercase.$invalid,
              'text-success': !_ctx.$v.newPassword.containsLowercase.$invalid
            }
              }, "An lowercase value is required", 2),
              _hoisted_86,
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.newPassword.containsNumber.$invalid,
              'text-success': !_ctx.$v.newPassword.containsNumber.$invalid
            }
              }, "An number value is required", 2),
              _hoisted_87,
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.newPassword.containsSpecial.$invalid,
              'text-success': !_ctx.$v.newPassword.containsSpecial.$invalid
            }
              }, "An special value (#?!@$%^&*-) is required", 2)
            ]),
            _createVNode("div", _hoisted_88, [
              _createVNode(_component_Password, {
                style: {"width":"100%"},
                inputStyle: "width:100%",
                toggleMask: "",
                feedback: false,
                modelValue: _ctx.confirm,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.confirm = $event)),
                onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$v.confirm.$touch())),
                placeholder: "Repeat New Password"
              }, null, 8, ["modelValue"]),
              _createVNode("small", {
                class: {
              'text-danger': _ctx.$v.confirm.sameAs.$invalid || _ctx.confirm == '',
              'text-success': !_ctx.$v.confirm.sameAs.$invalid
            }
              }, "The value must be equal to the New Password value", 2)
            ])
          ]),
          _createVNode("div", _hoisted_89, [
            _createVNode("div", _hoisted_90, [
              _createVNode("button", {
                disabled: 
              _ctx.$v.password.$error ||
              _ctx.$v.newPassword.$error ||
              _ctx.$v.confirm.$error ||
              _ctx.noPasswords()
            ,
                type: "button",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args))),
                class: "btn btn-primary btn-sat-street"
              }, " Update Password ", 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        header: "Anti-phishing Code",
        class: "shadow mt-3 mb-5 text-left"
      }, {
        default: _withCtx(() => [
          _hoisted_91,
          _createVNode("div", _hoisted_92, [
            _createVNode("div", _hoisted_93, [
              _withDirectives(_createVNode("input", {
                placeholder: "Anti-phishing Code",
                type: "text",
                disabled: _ctx.isLoadingAntiPhising,
                id: "anti-phishing-word",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.antiphishingWord = $event)),
                class: "form-control"
              }, null, 8, ["disabled"]), [
                [_vModelText, _ctx.antiphishingWord]
              ]),
              _createVNode("div", _hoisted_94, [
                (_ctx.antiphishingWord?.length < 6)
                  ? (_openBlock(), _createBlock("small", _hoisted_95, " At least 6 characters. "))
                  : _createCommentVNode("", true),
                _hoisted_96,
                _hoisted_97
              ])
            ])
          ]),
          _createVNode("div", _hoisted_98, [
            _createVNode("div", _hoisted_99, [
              _createVNode("button", {
                class: "btn btn-primary btn-sat-street mr-3",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.updateAntiphishing && _ctx.updateAntiphishing(...args))),
                disabled: _ctx.isLoadingAntiPhising || _ctx.antiphishingWord?.length < 6
              }, " Change ", 8, ["disabled"]),
              _createVNode("button", {
                class: "btn btn-danger",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.removeAntiphishingWord && _ctx.removeAntiphishingWord(...args))),
                disabled: _ctx.isLoadingAntiPhising || !_ctx.antiphishingWord
              }, " Remove ", 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        header: "Help Section",
        class: "shadow mt-3 mb-5 text-left"
      }, {
        default: _withCtx(() => [
          _hoisted_100,
          _createVNode("ul", _hoisted_101, [
            _hoisted_102,
            _hoisted_103,
            _hoisted_104,
            _createVNode("li", null, [
              _createVNode("a", {
                href: "#",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.openTerms && _ctx.openTerms(...args)))
              }, " Terms Of Service ")
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dialog, {
        header: "Satstreet",
        visible: _ctx.showTermsModal,
        "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => (_ctx.showTermsModal = $event)),
        maximizable: ""
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_105, [
            _hoisted_106,
            _hoisted_107,
            _createVNode(_component_Terms)
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}